import { useState } from "react";
import { useQuery } from "react-query";
import useDebounce from "./useDebounceSearch";
import { getContestantContests } from "services/contestant.service";

export default function useContantContests(userId, defaultQuery) {
  const [query, setQuery] = useState(
    defaultQuery || {
      page: 1,
      limit: 10,
      search: "",
    }
  );
  const debounceSearch = useDebounce(query.search, 1000);

  const { page } = query;
  const { isLoading, data, refetch } = useQuery(
    ["contestantContests", userId, page, debounceSearch],
    async () => await getContestantContests(userId, query),
    {
      enabled: userId ? true : false,
    }
  );

  const onQueryChange = (name, value) => {
    setQuery((q) => ({ ...q, [name]: value }));
  };

  const onFilter = (queryFilter) => {
    setQuery(queryFilter);
  };

  return { isLoading, data, onQueryChange, onFilter, refetch };
}
